import styled from 'styled-components';
import WithDirection from '../../config/withDirection';

const StyleWrapper = styled.div`
    display: block;
    background-color: rgba(35, 31, 32, 1);
    letter-spacing: 0.07em;
    z-index: 10;

    :after {
        display: ${props=>props.theme === "no-border-deco" ? "none" : "block"};
        content: '';
        height: 3px;
        background-color: rgba(12, 183, 148, 1); 
    }

    .header-row { display: flex; justify-content: space-between; align-items: center; padding: 0 64px; }
    .header-row:first-child { padding-top: 14px; }
    .header-row:last-child { padding-bottom: 17px; }

    .header-row .fill { flex-grow: 1; margin-bottom: 0; height: 1px; }

    /* Logo */
    .header-row .logo-container { min-width: 125px; width: 125px; }
    .header-row .logo-container a { display: block; }

    .search-app-bar { width: auto; }

    @media screen and (max-width: 767px) {
        .header-row { flex-wrap: wrap; align-items: flex-start; padding: 0 14px; }
        .header-row > *:not(:last-child) { margin-bottom: 14px; }
        .search-app-bar { min-width: 80%; }
    }

    @media screen and (min-width: 768px) and (max-width: 991px) {
        .header-row { padding: 0 28px; }
    }
`;
export default WithDirection(StyleWrapper);


// WEBPACK FOOTER //
// ./src/components/Headers/Wrapper.js